import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-sports',
  templateUrl: './events-sports.component.html',
  styleUrls: ['./events-sports.component.scss'],
})
export class EventsSportsComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/sports/1.jpg',
      thumbnail: 'assets/img/school/events/sports/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/2.jpg',
      thumbnail: 'assets/img/school/events/sports/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/3.jpg',
      thumbnail: 'assets/img/school/events/sports/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/4.jpg',
      thumbnail: 'assets/img/school/events/sports/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/5.jpg',
      thumbnail: 'assets/img/school/events/sports/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/6.jpg',
      thumbnail: 'assets/img/school/events/sports/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/7.jpg',
      thumbnail: 'assets/img/school/events/sports/7.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/8.jpg',
      thumbnail: 'assets/img/school/events/sports/8.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/9.jpg',
      thumbnail: 'assets/img/school/events/sports/9.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/10.jpg',
      thumbnail: 'assets/img/school/events/sports/10.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/11.jpg',
      thumbnail: 'assets/img/school/events/sports/11.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/12.jpg',
      thumbnail: 'assets/img/school/events/sports/12.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/13.jpg',
      thumbnail: 'assets/img/school/events/sports/13.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/14.jpg',
      thumbnail: 'assets/img/school/events/sports/14.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/11.jpg',
      thumbnail: 'assets/img/school/events/sports/11.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/15.jpg',
      thumbnail: 'assets/img/school/events/sports/15.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/16.jpg',
      thumbnail: 'assets/img/school/events/sports/16.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/17.jpg',
      thumbnail: 'assets/img/school/events/sports/17.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/18.jpg',
      thumbnail: 'assets/img/school/events/sports/18.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/19.jpg',
      thumbnail: 'assets/img/school/events/sports/19.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/20.jpg',
      thumbnail: 'assets/img/school/events/sports/20.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/21.jpg',
      thumbnail: 'assets/img/school/events/sports/21.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/22.jpg',
      thumbnail: 'assets/img/school/events/sports/22.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/sports/23.jpg',
      thumbnail: 'assets/img/school/events/sports/23.jpg',
      alt: 'Image 01',
    },
  ];
}
